import { render, staticRenderFns } from "./CancellationDesign.vue?vue&type=template&id=156cb7b4&scoped=true&"
import script from "./CancellationDesign.vue?vue&type=script&lang=js&"
export * from "./CancellationDesign.vue?vue&type=script&lang=js&"
import style0 from "./CancellationDesign.vue?vue&type=style&index=0&id=156cb7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cb7b4",
  null
  
)

export default component.exports